const translations = {
    workOrderNumber: 'Work Order #'
};

export default translations;
